<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <h4 style="color: #000; text-align: left" class="custom-user-name">
              Exam Taken
            </h4>
            <br />
            <div class="ml-3 mr-3">
              <v-select
              horizontal
              v-model="ExamTaken"
              :options="[
                { label: 'UPSR', id: 1 },
                { label: 'PT3', id: 2 },
                { label: 'SPM', id: 3 },
                { label: 'STPM', id: 4 },
              ]"
              placeholder="Select Users"
            />
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="bottom-center">
      <CButton class="btn-select-blue mt-5" @click="UpdateExam()">Save</CButton>
    </div>
    <div class="header-top">Change Exam</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);

export default {
  data: function () {
    return {
      ExamTaken: this.$route.query.examShortName,
      StudentId: this.$route.query.studentId,
      ExamId: this.$route.query.examId,
      exam: [],
      FilterExam: [],
      //ExamId: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetExam(this.user.id);
          }
        });
    },
    UpdateExam: function () {
      const formData = new FormData();
      formData.append("ManualStudentId", this.StudentId);
      formData.append("Exam", this.ExamTaken.id);

      return this.$API
        .post(this.$UpdateStudentDetail, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success save").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GetExam() {
      this.$API
        .get(this.$ExamListAuthorize, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.exam = response.data;
            this.FilterExam = this.exam;
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.exam, ["examName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ examName }) =>
          _.some([
            _.includes(!examName || examName.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilterExam = result;
      }
    },
    GoBack() {
      this.$router.back();
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="radio"] {
  opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
</style>